/**
 * This enum represents the possible valid values for sorting in the pdf generate modal.
 */
export var GenerateReportsModalSortColumn;
(function (GenerateReportsModalSortColumn) {
    GenerateReportsModalSortColumn["NAME"] = "name";
    GenerateReportsModalSortColumn["OWNER"] = "owner_name";
    GenerateReportsModalSortColumn["USER_MODIFY_DATE"] = "user_modify_date";
})(GenerateReportsModalSortColumn || (GenerateReportsModalSortColumn = {}));
